import { TextBlockDto, TextBlockResourceApi } from "../generated/dashboard-client";
import { AxiosPromise } from "axios";
import { dashboardApiConfig, ops } from "./config";

const api = new TextBlockResourceApi(dashboardApiConfig);

const TextBlockApi = {
  getAll(): AxiosPromise<TextBlockDto[]> {
    return api.getAll(ops());
  },

  get(id: number): AxiosPromise<TextBlockDto> {
    return api.get(id, ops());
  },

  getByName(name: string): AxiosPromise<TextBlockDto> {
    return api.getByName(name, ops());
  },

  create(dto: TextBlockDto): AxiosPromise<TextBlockDto> {
    return api.create(dto, ops());
  },

  update(dto: TextBlockDto): AxiosPromise<TextBlockDto> {
    return api.update(dto, ops());
  },

  delete(id: number) {
    return api._delete(id, ops());
  },

  getSiteNotices(): AxiosPromise<TextBlockDto[]> {
    return api.getSiteNotices(ops());
  },

  searchByContent(query: string): AxiosPromise<TextBlockDto[]> {
    return api.searchByContent(query, ops());
  },
};

export default TextBlockApi;